import { Validators } from '@angular/forms';

const PHONE_PATTERN =
  /^$|^\+?(?=.*\d)(?!.*\s{2})(?!.*-{2})(?!.*[()]{2})[\d\s()-]+$/;

export const PHONE_VALIDATORS = [
  Validators.maxLength(21),
  Validators.pattern(PHONE_PATTERN),
];
